import React from "react";

export const ArrowIcon = ({ nameOfClass, handleClick, value }) => (
    <svg className={nameOfClass} onClick={() => handleClick(value)} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.460405 9.70571C-0.153468 10.4216 -0.153468 11.5841 0.460405 12.3L8.31799 21.4631C8.93186 22.179 9.92879 22.179 10.5427 21.4631C11.1565 20.7472 11.1565 19.5847 10.5427 18.8688L5.36157 12.8326H20.4285C21.2977 12.8326 22 12.0137 22 11C22 9.98633 21.2977 9.16738 20.4285 9.16738H5.36648L10.5378 3.1312C11.1516 2.41533 11.1516 1.25277 10.5378 0.5369C9.92388 -0.178967 8.92695 -0.178967 8.31308 0.5369L0.455494 9.69999L0.460405 9.70571Z"/>
    </svg>
);
